import { FC } from 'react';
import { Box, HStack, Text, Button, IconButton } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { FiMenu, FiLogOut } from 'react-icons/fi';
import { VersionBadge } from './VersionBadge';

interface HeaderProps {
  onMenuClick?: () => void;
}

/**
 * ヘッダーコンポーネント
 * AI使用回数表示とログアウト機能を提供
 */
export const Header: FC<HeaderProps> = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Box
      as="header"
      h="16"
      bg="white"
      borderBottomWidth="1px"
      borderBottomColor="gray.200"
      px={{ base: 4, md: 6 }}
      position="sticky"
      top="0"
      zIndex="10"
      shadow="sm"
    >
      <HStack h="full" justify="space-between" align="center">
        {/* 左側: メニューボタン（モバイル） */}
        <HStack gap={3}>
          {onMenuClick && (
            <IconButton
              aria-label="メニューを開く"
              variant="ghost"
              display={{ base: 'flex', lg: 'none' }}
              onClick={onMenuClick}
            >
              <FiMenu size={24} />
            </IconButton>
          )}
          <Text fontSize="lg" fontWeight="bold" color="gray.700">
            ブリーダー管理システム
          </Text>
          <VersionBadge />
        </HStack>

        {/* 右側: ユーザー情報とログアウト */}
        <HStack gap={4}>
          {user && (
            <>
              {/* ユーザー名 */}
              <Box display={{ base: 'none', md: 'block' }}>
                <Text fontSize="sm" color="gray.700" fontWeight="medium">
                  {user.userName}
                </Text>
              </Box>

              {/* ログアウトボタン */}
              <Button
                size="sm"
                colorPalette="red"
                variant="outline"
                onClick={handleLogout}
                display={{ base: 'none', sm: 'flex' }}
              >
                <FiLogOut size={16} />
                <Text ml={2}>ログアウト</Text>
              </Button>

              {/* モバイル用ログアウトアイコン */}
              <IconButton
                aria-label="ログアウト"
                size="sm"
                colorPalette="red"
                variant="outline"
                onClick={handleLogout}
                display={{ base: 'flex', sm: 'none' }}
              >
                <FiLogOut size={16} />
              </IconButton>
            </>
          )}
        </HStack>
      </HStack>
    </Box>
  );
};
